// src/components/hotelMealPlans/Table/HotelMealPlansTableRow.jsx
import React from "react";
import { TableRow, TableCell, IconButton, Checkbox, Chip } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useTranslation } from "react-i18next";

const HotelMealPlansTableRow = ({
    hotelMealPlan,
    index,
    isDark,
    page,
    perPage,
    sortBy,
    sortDir,
    totalItems,
    selectedIds,
    onRowCheckboxClick,
    onMenuOpen,
    isArchive = false,
    menuDisabled = false,
}) => {
    const { i18n } = useTranslation();
    const lng = i18n.language || "en";
    const isArabic = lng === "ar";

    const serial =
        sortDir === "asc"
            ? (page - 1) * perPage + index + 1
            : (page - 1) * perPage + (totalItems - index);

    const isOdd = index % 2 === 0;
    const isSelected = selectedIds.includes(hotelMealPlan?.id);

    // Status badge
    const isActive = hotelMealPlan?.is_active;
    const statusLabel = isArabic
        ? (isActive ? "نشط" : "معطل")
        : (isActive ? "Active" : "Disabled");

    return (
        <TableRow
            hover
            sx={{
                backgroundColor: isOdd
                    ? isDark
                        ? "rgba(55,65,81,0.45)"
                        : "rgba(249,250,251,0.9)"
                    : "transparent",
            }}
        >
            <TableCell padding="checkbox">
                <Checkbox
                    color="primary"
                    checked={isSelected}
                    onClick={(e) => onRowCheckboxClick(e, hotelMealPlan?.id)}
                    inputProps={{ "aria-labelledby": `hotelMealPlan-${hotelMealPlan?.id}` }}
                />
            </TableCell>

            <TableCell align="right">
                <IconButton
                    size="small"
                    disabled={menuDisabled}
                    onClick={(e) => {
                        e.stopPropagation();
                        onMenuOpen(e, hotelMealPlan);
                    }}
                    sx={{ color: isDark ? "#E5E7EB" : "#1F2937" }}
                >
                    <MoreVertIcon fontSize="small" />
                </IconButton>
            </TableCell>
            <TableCell>{serial}</TableCell>

            <TableCell sx={{ color: isDark ? "#E5E7EB" : "#1F2937" }}>
                {hotelMealPlan?.name?.ar || "-"}
            </TableCell>

            <TableCell sx={{ color: isDark ? "#E5E7EB" : "#1F2937" }}>
                {hotelMealPlan?.name?.en || "-"}
            </TableCell>

            <TableCell>
                <Chip
                    label={statusLabel}
                    size="small"
                    color={isActive ? "success" : "default"}
                    sx={{
                        fontWeight: 500,
                        minWidth: 70,
                    }}
                />
            </TableCell>

            <TableCell align="right">
                <IconButton
                    size="small"
                    disabled={menuDisabled}
                    onClick={(e) => {
                        e.stopPropagation();
                        onMenuOpen(e, hotelMealPlan);
                    }}
                    sx={{ color: isDark ? "#E5E7EB" : "#1F2937" }}
                >
                    <MoreVertIcon fontSize="small" />
                </IconButton>
            </TableCell>
        </TableRow>
    );
};

export default HotelMealPlansTableRow;
